"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoCallout = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _style = require("../callout/style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var InfoCallout = (0, _styledComponents["default"])(_style.StyledCallout).withConfig({
  displayName: "style__InfoCallout",
  componentId: "ngcljj-0"
})(["margin-bottom:20px;padding:0;border:none;background:none;a{text-decoration:underline;color:inherit;}"]);
exports.InfoCallout = InfoCallout;